import { useMemo } from 'react';
import { useScorecardDependencies } from '@/creditflowresearch/application/League/Scorecard/hooks/useScorecardDependencies';
import { useScorecardOperations } from '@/creditflowresearch/application/League/Scorecard/hooks/useScorecardOperations';
import { IScorecardProps } from '@/creditflowresearch/application/League/Scorecard/types';

export const useScorecard = (props: IScorecardProps) => {
  const {
    state,
    stateActions,
    periods,
    type,
    getCompany,
    getStandings,
    productsList,
    regionsList,
  } = useScorecardDependencies(props);

  const { filterOperations, tableOperations, pageOperations } = useScorecardOperations({
    props,
    state,
    stateActions,
    periods,
    type,
    productsList,
    regionsList,
    getStandings,
  });

  return useMemo(() => ({
    state,
    activeProductIds: filterOperations.activeProductIds,
    activeRegionIds: filterOperations.activeRegionIds,
    filterPayload: filterOperations.scorecardFilters,
    getCompany,
    getStandings,
    ...tableOperations,
    ...pageOperations,
    initProductRegionFilters: filterOperations.initProductRegionFilters,
  }), [
    state,
    filterOperations.activeProductIds,
    filterOperations.activeRegionIds,
    filterOperations.scorecardFilters,
    getCompany,
    getStandings,
    tableOperations,
    pageOperations,
    filterOperations.initProductRegionFilters,
  ]);
};
